import { useFormik } from 'formik';
import Select from 'react-select';

import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import {
  updateAttendenceAdjustment,
  getAttendenceAdjustmentByPersonId,
} from '../../../../store/HR/Person/AttendanceAdjustmentSlice';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useGetPersons from '../../../../hooks/HR/use-get-persons';
import { AttendanceAdjustmentSchema } from '../../../ValidationForm/validationSchema';
import { getAttendenceAdjustmentById } from '../../../../store/HR/Person/AttendanceAdjustmentSlice';
import Loading from '../../../../components/Shared/Loader/Loading';
import useGetPermissionsType from '../../../../hooks/Lookups/use-Get_Permissions_Type';
  import { usePermissions } from '@Helper/Permisstions/usePermissions';
const UpdateAttendanceAdjustment = ({ id, isAme = false }: { id: string; isAme?: boolean }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const { dataEmployees, loading: loading2 } = useGetPersons();
  const { Permissions_Type } = useGetPermissionsType();
  const {HasPermission} = usePermissions()
  useEffect(() => {
    dispatch(getAttendenceAdjustmentById(id));
  }, [dispatch, id]);

  const {
    AttendenceAdjustmentById: data,

    loadingById: loading,
    errorById: error,
  } = useAppSelector((s) => s.AttendanceAdjustment);

  const formik = useFormik({
    initialValues: {
      id: data.id,
      personId: data.personId ?? '',
      startDateTime: data.startDateTime ?? '',
      endDateTime: data.endDateTime ?? '',
      attendenceAdjustmentType: data.attendenceAdjustmentType ?? '',
      reason: data.reason ?? '',
      isAme: data.isAme ?? false,
      // status: 0,
    },

    validationSchema: AttendanceAdjustmentSchema(t),
    enableReinitialize: true,

    onSubmit: async (values) => {
      try {
        const response = await dispatch(
          updateAttendenceAdjustment({
            id: data.id,
            personId: values.personId,
            startDateTime: values.startDateTime,
            endDateTime: values.endDateTime,
            attendenceAdjustmentType: values.attendenceAdjustmentType,
            reason: values.reason,
            isAme: false,
            // status: 0,
          })
        );
        debugger;
        if (response?.payload?.succeeded === true) {
          CustomAlert({ action: 'Edit' });
          dispatch(getAttendenceAdjustmentByPersonId({ id: values.personId }));
        } else {
          CustomAlert({ action: 'Error', msg: response?.payload?.message });
          formik.resetForm();
        }
      } catch (error) {
        console.log(error);
        CustomAlert({ action: 'Error' });
      } finally {
        formik.setSubmitting(false);
      }
    },
  });

  return (
    <>
      <Loading loading={loading} error={error}>
        <Form onSubmit={formik.handleSubmit}>
          <div className="row">
            <div className="col-xl-6">
              <div className="form-group mb-3">
                <label className="form-label">{t('From')}</label>
                <Form.Control
                  disabled={isAme}
                  className="form-control"
                  // type="text"
                  type="datetime-local"
                  autoComplete="off"
                  name="startDateTime"
                  onChange={formik.handleChange}
                  value={formik.values.startDateTime || ''}
                  isInvalid={!!(formik.touched.startDateTime && formik.errors.startDateTime)}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.touched.startDateTime && formik.errors.startDateTime}
                </Form.Control.Feedback>
              </div>
            </div>

            <div className="col-xl-6">
              <div className="form-group mb-3">
                <label className="form-label">{t('To')}</label>
                <Form.Control
                  disabled={isAme}
                  className="form-control"
                  // type="text"
                  type="datetime-local"
                  autoComplete="off"
                  name="endDateTime"
                  onChange={formik.handleChange}
                  value={formik.values.endDateTime || ''}
                  isInvalid={!!(formik.touched.endDateTime && formik.errors.endDateTime)}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.touched.endDateTime && formik.errors.endDateTime}
                </Form.Control.Feedback>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="form-group mb-3">
                <label className="form-label">{t('EmployeeName')}</label>
                <Select
                  isDisabled={isAme}
                  classNamePrefix="react-select"
                  // className="w-100"
                  className={`w-100 ${
                    formik.touched.personId && formik.errors.personId ? 'border border-danger' : ''
                  }`}
                  isLoading={loading2}
                  isSearchable={true}
                  isClearable
                  name="personId"
                  options={dataEmployees}
                  value={
                    formik.values.personId === null
                      ? null
                      : dataEmployees?.find((f: any) => f.value === formik.values.personId)
                  }
                  onChange={(option) => {
                    formik.setFieldValue('personId', option === null ? null : option.value);
                  }}
                  placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                  formatOptionLabel={(option) => (
                    <div className="d-flex justify-content-between   ">
                      <div className="">{option.label}</div>
                      <div className="text-theme fw-bold">{option.employeeNumber}</div>
                    </div>
                  )}
                  filterOption={(candidate, inputValue) => {
                    // البحث في الاسم أو رقم الموظف
                    const searchValue = inputValue.toLowerCase();
                    const labelMatches = candidate?.label?.toLowerCase()?.includes(searchValue);
                    const numberMatches = candidate?.data?.employeeNumber
                      ?.toLowerCase()
                      .includes(searchValue);
                    return labelMatches || numberMatches;
                  }}
                />
                <div className="small">{formik.touched.personId && formik.errors.personId}</div>
              </div>
            </div>

            <div className="col-xl-6">
              <div className="form-group mb-3">
                <label className="form-label">{t('Type')}</label>
                <Form.Select
                  disabled={isAme}
                  className="form-select"
                  name="attendenceAdjustmentType"
                  onChange={formik.handleChange}
                  value={formik.values.attendenceAdjustmentType || ''}
                  isInvalid={
                    !!(
                      formik.touched.attendenceAdjustmentType &&
                      formik.errors.attendenceAdjustmentType
                    )
                  }>
                  <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                  {Permissions_Type &&
                    Permissions_Type?.map((item: any, idx: any) =>
                      item.list?.map((list: any) => (
                        <option key={++idx} value={list.lookupCode}>
                          {i18n.language === 'ar' ? list.meaning2 : list.meaning}
                        </option>
                      ))
                    )}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {formik.touched.attendenceAdjustmentType &&
                    formik.errors.attendenceAdjustmentType}
                </Form.Control.Feedback>{' '}
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div className="form-group mb-3">
              <label className="form-label">{t('Reason')}</label>
              <Form.Control
                disabled={isAme}
                className="form-control"
                as="textarea"
                rows={3}
                name="reason"
                onChange={formik.handleChange}
                value={formik.values.reason || ''}
                isInvalid={!!formik.errors.reason}
              />
              <Form.Control.Feedback type="invalid">{formik.errors.reason}</Form.Control.Feedback>
            </div>
          </div>
          {!isAme && (
            <div className="text-center">
              <div className="d-flex justify-content-between gap-2">
                {HasPermission('EditRaqPermissions') && (
                  <button
                    disabled={formik.isSubmitting}
                    type="submit"
                    className="btn btn-lg btn-theme mb-1 w-100">
                    {formik.isSubmitting ? (
                      <div className="spinner-border spinner-border-sm me-2"></div>
                    ) : (
                      <i className="fas fa-save fa-lg fa-fw me-2"></i>
                    )}
                    {t('Save')}
                  </button>
                )}

                <button
                  type="button"
                  className="btn btn-lg  btn-default mb-1 w-100"
                  data-bs-dismiss="modal"
                  id="closeModalJob">
                  <i className="fa fa-power-off fa-fw me-1"></i> {t('Cancel')}
                </button>
              </div>
            </div>
          )}
        </Form>
      </Loading>
    </>
  );
};

export default UpdateAttendanceAdjustment;
